import React, { useRef } from "react";
import "./progressloader.css";

import { zoomies } from "ldrs";

zoomies.register();

const ProgessLoader = ({ loaderWidth }) => {
  const containerRef = useRef();
  return (
    <div className="relative mx-auto flex justify-center ">
      <div>
        {loaderWidth === "0.00" ? (
          <div class="">
            <l-zoomies
              size="150"
              stroke="9"
              bg-opacity="0.4"
              speed="1.4"
              color="white"
            ></l-zoomies>
          </div>
        ) : (
          <div className="w-[150px] relative h-[10px] my-[8px] rounded-lg bg-[#ffffff65]">
            <div
              ref={containerRef}
              role="progressbar"
              style={{
                width: `${loaderWidth}%`,
                height: "10px",
              }}
              className={`rounded-lg absolute bg-white`}
            ></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgessLoader;
